import { utilTick } from "./utilTick";
import { utilTime } from "./utilTime";
var UtilFps = /** @class */ (function () {
    function UtilFps() {
        var _this = this;
        this.gameJoinedFpsBuffer = 63;
        this.animationFpsArraySize = 150;
        this.fpsAccumulated = 0;
        this.totalFps = 0;
        this.fps = 0;
        this.minFps = 0;
        this.maxFps = 0;
        this.startTime = utilTime.now();
        this.fpsCounter = 0;
        this.animationFps = [];
        this.getFps = function () { return _this.fps; };
        this.getMaxFps = function () { return _this.maxFps; };
        this.getMinFps = function () { return _this.minFps; };
        this.getAvgFps = function () { return Math.floor(_this.totalFps / _this.fpsCounter) || 0; };
        this.getAnimationAvgFps = function () {
            var animationFps = _this.animationFps && _this.animationFps.length > 0 ? _this.animationFps.slice() : [];
            _this.animationFps = undefined;
            var total = animationFps.reduce(function (acc, c) { return acc + c; }, 0);
            return Math.floor(total / animationFps.length);
        };
        this.startFpsTracking = function () {
            _this.fpsAccumulated++;
            _this.fpsCounter++;
            var elapsedTime = utilTime.secondsElapsedSince(_this.startTime);
            _this.setFps(Math.floor(_this.fpsAccumulated / elapsedTime));
            if (elapsedTime > 1) {
                _this.resetFpsCalculation();
            }
        };
        this.stopFpsTracking = function () {
            _this.frameSub$.unsubscribe();
        };
        this.resetFpsCalculation = function () {
            _this.fpsAccumulated = 0;
            _this.startTime = new Date().getTime();
        };
        this.setFps = function (fps) {
            _this.fps = fps;
            _this.totalFps += fps;
            if (_this.animationFps) {
                _this.animationFps.push(fps);
                if (_this.animationFps.length > _this.animationFpsArraySize) {
                    _this.animationFps.shift();
                }
            }
            _this.maxFps = Math.max(_this.maxFps, fps);
            _this.minFps = Math.min(_this.minFps, fps);
        };
        this.frameSub$ = utilTick.frame$.subscribe(this.startFpsTracking);
    }
    return UtilFps;
}());
export var utilFps = new UtilFps();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilFps.ts
// module id = 411
// module chunks = 3